/* @flow */

import React from 'react';
import { Message } from 'semantic-ui-react';

const View = () => (
  <Message
    icon="folder open outline"
    header="Espace personnel"
    content={`Les espaces personnels sont gérés via le module dédié.`}
  />
);

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/myspace/View.js